export enum VerificationStatus {
  UNCONFIRMED = 'Unconfirmed',

  PROVISIONAL = 'Provisional',
}
